import React from 'react';
import clsx from 'clsx';

interface TourStepTrackerProps {
	currentStep: number;
	totalSteps: number;
	className?: string;
}

export const TourStepTracker: React.FC<TourStepTrackerProps> = ({
	currentStep,
	totalSteps,
	className,
}) => (
	<div className={clsx('flex items-center gap-6 shrink-0', className)}>
		{Array.from({ length: totalSteps }).map((_, index) => {
			const isActive = index === currentStep - 1;
			return (
				<span
					key={index}
					className={clsx('rounded-full', {
						'w-5 h-5 bg-primary': isActive,
						'w-3 h-3 bg-[#0D061614]': !isActive,
					})}
				/>
			);
		})}
	</div>
);
